export enum ApplicationState {
  NewCandidate = 'NewCandidate',
  WillBeContacted = 'WillBeContacted',
  MoreInfoNeeded = 'MoreInfoNeeded',
  InApplicationProcess = 'InApplicationProcess',
  InApplicationProcessPostInterview = 'InApplicationProcessPostInterview',
  Offer = 'Offer',
  Hired = 'Hired',
  OfferRejected = 'OfferRejected',
  OfferRetracted = 'OfferRetracted',
  RejectedWithReason = 'RejectedWithReason',
}

export enum HotlistStatus {
  New = 'New',
  NotInterested = 'NotInterested',
  Interested = 'Interested',
  CandidateDeclined = 'CandidateDeclined',
  Accepted = 'Accepted',
}

export enum ApplicantsFiltersStatus {
  All = 'All',
  Favorites = 'Favorites',
  New = 'New',
  InterviewArranged = 'InterviewArranged',
  Processing = 'Processing',
  OfferSent = 'OfferSent',
  Hired = 'Hired',
  Rejected = 'Rejected',
}

export enum HotlistFiltersStatus {
  Favorites = 'Favorites',
  New = 'New',
  RequestSent = 'RequestSent',
  RequestAccepted = 'RequestAccepted',
  RequestDeclined = 'RequestDeclined',
}

export enum HotlistFilterDegree {
  Empty = 'Empty',
  NoDegree = 'NoDegree',
  HasDegree = 'HasDegree',
}

export enum HotlistDateFilter {
  AllTime = 'AllTime',
  ThisWeek = 'ThisWeek',
  ThisMonth = 'ThisMonth',
}

export const HotlistDateFilterValues = Object.values(HotlistDateFilter)
